<template>
	<div class="banners__description-block-content">
		<div v-for="(item, idx) in block.items" :key="idx" class="banners__description-block-item">
			<p class="banners__description-block-item-title">
				{{ $rt(item.title) }}
			</p>
			<ul class="banners__description-block-item-list">
				<li v-for="(button, index) in item.buttons" :key="index">
					<button
						type="button"
						class="banners__description-btn"
						:class="{ active: selectedFormat === rt(button) }"
						@click="handleSelectFormat(button)">
						{{ $rt(button) }}
					</button>
				</li>
			</ul>
		</div>
	</div>
</template>

<script setup lang="ts">
	type ButtonsItem = {
		title: string
		buttons: string[]
	}

	const props = defineProps<{
		block: { items?: ButtonsItem[] }
		selectedFormat: string
	}>()

	const emit = defineEmits<{
		(event: 'select-format', value: string): void
	}>()

	const { rt } = useI18n()

	const block = computed(() => ({
		items: props.block.items ?? [],
	}))

	const handleSelectFormat = (size: string) => {
		emit('select-format', rt(size))
	}
</script>

<style lang="scss" scoped>
	.banners__description-block-content {
		display: flex;
		flex-direction: column;
		gap: 24px;
		
	}
	.banners__description-block-item {
		display: flex;
		flex-direction: column;
		gap: 8px;
	}
	.banners__description-block-item-list {
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
	}
	.banners__description-btn {
		padding: 8px;
		border: 1.5px solid var(--primary);
		border-radius: 50px;
		transition: 0.3s background-color;
		@media (max-width: 575.98px) {
			pointer-events: none;
			border-color: var(--gray400);
		}
		&.active {
			background-color: var(--primary);
			@media (max-width: 575.98px) {
				background-color: var(--gray400);
			}
		}
		&:hover {
			background-color: var(--primary-hover);
		}
	}
</style>
